import { Article } from 'shared/components/Article';
import { useLazyArticleImage } from 'shared/hooks/useLazyArticleImage';
import type { TArticle } from 'shared/types/carousel';

interface IArticleContainerProps extends TArticle {}

export const ArticleContainer: React.FC<IArticleContainerProps> = ({ image, ...article }) => {
  const { src, isImageLoaded, containerRef, onImageLoad, onImageError } = useLazyArticleImage({ image });

  return (
    <Article
      ref={containerRef}
      {...article}
      src={src}
      isImageLoaded={isImageLoaded}
      onImageLoad={onImageLoad}
      onImageError={onImageError}
    />
  );
};
